import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';
import { LoanGtmService } from 'projects/apna-lib/src/lib/services/loan-gtm.service';
import { UserIdentityService } from 'projects/apna-lib/src/lib/services/user-identity.service';
import mixpanel from "mixpanel-browser/src/loader-module";
import { DatePipe } from '@angular/common';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { HeaderInterface } from 'projects/apna-lib/src/lib/interfaces/common-interface';
declare let gtag: Function;
export interface CurrentDetails {
  email?: string,
  mobile?: string,
  pan?: string
}

@Component({
  selector: 'fa-loan-personal-details',
  templateUrl: './loan-personal-details.component.html',
  styleUrls: ['./loan-personal-details.component.scss']
})
export class LoanPersonalDetailsComponent implements OnInit {

  model: any = {};
  dataModel: string = "users";
  otpDataModel = 'users/login-with-mobile-otp';
  isPartnerLink: boolean = false;
  partnerLogo: string;
  otpModel = {
    mobile: this.loanService.studentDetails?.mobile
  };
  targetIntakeOptions = this.configService.getConfig1("foreignAdmits", "targetIntakeOptions");
  targetCountryOptions = this.configService.getConfig1("foreignAssist", "countryOptions");
  targetDegreeOptions = this.configService.getConfig1("foreignAssist", "degreeOptions");
  professionalOptions = this.configService.getConfig1("foreignAssist", "professionalOptions");
  loanWidgetConfig = this.configService.getConfig1("loanWidgetConfig")
  timer: number = 14;
  showOtp: boolean = false;
  currentDetails: CurrentDetails = {};
  defaultAddress: string;
  defaultCurrentAddress: string;
  isIndianNumber: boolean = true;
  orientation: String;

  step: String = "firstStep";
  steps: any = this.loanWidgetConfig?.personalDetailsStepperConfig

  @ViewChild('content') content;
  userData: {};
  userDetails: any;

  identify(user_id, userData = {}) {
    mixpanel.identify(user_id, userData)
  }
  trackEvent(event, data = {}) {
    mixpanel.track(event, data)
  }

  configPersonalDetailsHeader: HeaderInterface = {
    title: "Tell us about yourself",
    back: {
      link: '/',
      step: 'firstStep',
    }
  }

  otpFields: FormlyFieldConfig[] = [
    {
      key: 'otp',
      type: 'fa-otp',
      className: "rounded rounded-1",
      templateOptions: {
        label: 'Enter OTP',
        placeholder: 'Enter OTP'
      },
    },
  ];

  layout: FormlyFieldConfig[];
  layoutForMobileView: FormlyFieldConfig[];

  constructor(
    public loanService: LoanGtmService,
    private route: Router,
    private configService: ConfigService,
    private activatedRoute: ActivatedRoute,
    private apiHelper: ApiHelperService,
    private userIdentity: UserIdentityService,
    private datePipe: DatePipe,
    public breakpointObserver: BreakpointObserver
  ) { }

  ngOnInit(): void {
    this.breakpointObserver
      .observe(['(max-width: 576px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.orientation = 'vertical';
        } else {
          this.orientation = 'horizontal';
        }
      });

    if (typeof window !== 'undefined' && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('qa') && !window.location.host.includes('uat')) {
      mixpanel.init('36f7bc976b3c6dc024e372be5c7d26f8'); //change the token as per environment
    }
    const puid = this.activatedRoute.snapshot.paramMap.get('puid');

    if (puid) {

      localStorage.setItem('puid', puid);
      this.isPartnerLink = true;
      if (!this.loanService?.partnerDetails) {
        this.getPartnerDetails(puid);
      }
      else {
        this.partnerLogo = this.loanService.partnerDetails?.company?.showCompanyLogo ? this.loanService?.partnerDetails?.company?.logo : undefined;
      }
    }

    if (!this.loanService?.studentDetails?.mobile) {
      if (this.isPartnerLink) {
        this.route.navigate([puid]);
      }
      this.route.navigate([''])
    }

    this.dataPreprocessor();
    this.checkSessionStorageSteps()
    this.checkUserLoggedIn()
  }

  checkUserLoggedIn() {
    if (!this.loanService.studentDetails?.mobile) {
      if (this.isPartnerLink) {
        this.route.navigate([this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['']);
    }
    else if (!this.userIdentity.isValidToken()) {
      if (this.isPartnerLink) {
        this.route.navigate([this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['/']);
    }
    else if (!this.userIdentity.isLoggedIn.getValue()) {
      if (this.isPartnerLink) {
        this.route.navigate(['personal-details/' + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['/personal-details']);
    }
    this.dataPreprocessor();
  }

  checkSessionStorageSteps() {
    let stepFromSessionStorage = sessionStorage.getItem("stepHeading");

    if (stepFromSessionStorage === 'secondStep') {
      sessionStorage.removeItem("stepHeading")
      this.step = 'secondStep';
      let newModel = { ...this.model };
      this.model = undefined;
      this.model = newModel;
      this.steps.steps[0].status = "complete"
      this.configPersonalDetailsHeader.title = "What do you do?"
    }
    else {
      this.configPersonalDetailsHeader.title = "Tell us about yourself"
      this.step = "firstStep";
      let newModel = { ...this.model };
      this.model = undefined;
      this.model = newModel;
    }
  }

  getPartnerDetails(partnerUid: string) {
    this.apiHelper.getDataById("users/partner", partnerUid).subscribe((response: any) => {
      let partnerDetails = { ...response };
      if (partnerDetails) {
        this.loanService.studentDetails.parentId = partnerDetails?.id;
        this.loanService.studentDetails.puid = partnerDetails?.uid;
        this.loanService.partnerDetails = { ...partnerDetails };
        this.partnerLogo = partnerDetails?.company?.showCompanyLogo ? partnerDetails?.company?.logo : undefined;

      }
      else {
        this.isPartnerLink = false;
      }
    })
  }

  dataPreprocessor() {
    this.userDetails = this.userIdentity.getUserDetails();
    this.isIndianNumber = this.loanService.isMobileIndian(this.loanService.studentDetails?.mobile);
    this.model = { ...this.loanService.studentDetails };
    if (this.model.dob) {
      this.model.dob = this.datePipe.transform(this.model.dob, "yyyy-MM-dd");
    }
    if (this.model.pan) {
      this.model.pan = this.model?.pan?.toUpperCase();
    }
    this.setDefaultAddress();
    this.currentDetails.pan = this.model.pan;
    this.currentDetails.email = this.model.email;
    this.model.id = this.userDetails?.id;
    delete this.model?.universityVendors;
    delete this.model?.kycStatus;
    if (this.orientation === 'horizontal') {
      this.setLayout();
    } else {
      this.setMobileLayout();
    }
  }

  setMobileLayout() {
    this.layoutForMobileView = [
      {
        fieldGroup: [
          {
            className: "col-lg-12 col-6",
            key: "firstName",
            type: "input",
            templateOptions: {
              required: true,
              label: "First Name",
              placeholder: "Eg. Kiara"
            },
            hideExpression: () => {
              return this.step !== 'firstStep'
            },
            validation: {
              messages: {
                required: 'First Name is required',
              },
            }
          },

          {
            className: "col-lg-12 col-6",
            key: "lastName",
            type: "input",
            templateOptions: {
              required: true,
              label: "Last Name",
              placeholder: "Eg. Sharma"
            },
            hideExpression: () => {
              return this.step !== 'firstStep'
            },
            validation: {
              messages: {
                required: 'Last Name is required',
              },
            }
          },

          {
            className: "col-12",
            key: "email",
            type: "emailR",
            templateOptions: {
              required: true,
              label: "Email Address",
              placeholder: "Eg. xyz23@gmail.com"
            },
            hideExpression: () => {
              return this.step !== 'firstStep'
            },
            asyncValidators: {
              alreadyApplied: {
                expression: async (control) => {
                  if (control) {
                    let val = await this.checkEmailAvailable(control.value)
                    if (!val?.canContinue) {
                      //this.apiHelper.openSnackBar('Email address already has an Active Loan Application/User already exists')
                    }
                    return val.canContinue;
                  }

                  return true;
                },
                message: (error, field: FormlyFieldConfig) => `${field.formControl.value} already exists`,
              },
            },
            validation: {
              messages: {
                required: 'Email is required',
                alreadyApplied: 'You have already applied.'
              },
            }
          },

          {
            className: "col-12",
            key: "address",
            fieldGroupClassName: 'row',
            fieldGroup: [
              {
                className: 'col-12',
                key: 'pincode',
                type: 'autocomplete',
                templateOptions: {
                  label: 'Enter Pincode (As per Permanent Address)',
                  required: true,
                  placeholder: 'Type and select Pincode',
                  autocompleteOptions: {
                    name: 'pincode',
                    isEditable: false,
                    value: 'pincode',
                    defaultValue: this.defaultAddress,
                    fields: ['pincode', 'city', 'state'],
                    dataModel: 'locations',
                    onSelect: (item: any) => {
                      this.model.address = {
                        pincode: item.pincode,
                        city: item.city,
                        state: item.state,
                        country: item.country,
                        region: item.region
                      }

                      setTimeout(() => {
                        let newModel = { ...this.model };
                        this.model = undefined;
                        this.model = newModel;
                      }, 100);
                    },
                    dataParams: {
                      aggregate: true
                    }
                  }
                },
                hideExpression: () => {
                  return !this.isIndianNumber || this.step !== 'firstStep';
                }
              },

              {
                className: "col-12",
                key: "city",
                type: "input",
                templateOptions: {
                  label: "City",
                  placeholder: "Eg. Bangalore",
                  required: true,
                },
                validation: {
                  messages: {
                    required: 'City is required',
                  },
                },
                hideExpression: () => {
                  return this.isIndianNumber || this.step !== 'firstStep'
                }
              },

              {
                className: "col-12",
                key: "state",
                type: "input",
                templateOptions: {
                  label: "State",
                  placeholder: "Eg. Karnataka",
                  required: true,
                },
                validation: {
                  messages: {
                    required: 'State is required',
                  },
                },
                hideExpression: () => {
                  return this.isIndianNumber || this.step !== 'firstStep'
                }
              },

              {
                className: "col-12",
                key: "country",
                type: "input",
                templateOptions: {
                  label: "Country",
                  placeholder: "Eg. India",
                  required: true,
                },
                validation: {
                  messages: {
                    required: 'Country is required',
                  },
                },
                hideExpression: () => {
                  return this.isIndianNumber || this.step !== 'firstStep'
                }
              }
            ],
          },

          {
            className: "col-12",
            key: "currentAddress",
            fieldGroupClassName: 'row',
            fieldGroup: [
              {
                className: 'col-12',
                key: 'pincode',
                type: 'autocomplete',
                templateOptions: {
                  label: 'Enter Pincode (As per Current Address)',
                  placeholder: 'Type and select Pincode',
                  autocompleteOptions: {
                    name: 'pincode',
                    isEditable: false,
                    value: 'pincode',
                    fields: ['pincode', 'city', 'state'],
                    dataModel: 'locations',
                    defaultValue: this.defaultCurrentAddress,
                    onSelect: (item: any) => {
                      this.model.currentAddress = {
                        pincode: item.pincode,
                        city: item.city,
                        state: item.state,
                        country: item.country,
                        region: item.region
                      }

                      setTimeout(() => {
                        let newModel = { ...this.model };
                        this.model = undefined;
                        this.model = newModel;
                      }, 100);
                    },
                    dataParams: {
                      aggregate: true
                    }
                  }
                },
              },
            ],
            hideExpression: () => {
              return !this.isIndianNumber || this.step !== 'firstStep';
            }
          },

          {
            className: "col-12",
            type: "dob",
            key: "dob",
            templateOptions: {
              label: "Date of birth",
              required: true,
              placeholder: "Enter date of birth"
            },
            expressionProperties: {
              "templateOptions.max": (model) => {
                return this.datePipe.transform(new Date(), 'yyyy-MM-dd');
              }
            },
            hideExpression: () => {
              return this.step !== 'firstStep'
            }
          },

          {
            className: "col-12 buttonRadio",
            key: "loanProcessInformation",
            fieldGroupClassName: 'row',
            fieldGroup: [
              {
                className: 'col-12',
                key: 'professional',
                type: 'radio',

                templateOptions: {
                  label: 'I am a',
                  required: true,
                  placeholder: 'Select an Option',
                  options: this.professionalOptions
                },
                hideExpression: () => {
                  return this.step != 'secondStep'
                }
              },
              {
                className: 'col-12 mb-lg-2 mb-2',
                key: 'workExperience',
                type: "input",
                templateOptions: {
                  type: "number",
                  label: 'Your work experience in Months',
                  required: true,
                  min: 1,
                  placeholder: 'Enter work experience',
                },
                validation: {
                  messages: {
                    min: "Minimum experience should be greater than 0"
                  },
                },
                hideExpression: () => {
                  if (this.model?.loanProcessInformation) {
                    return this.model?.loanProcessInformation?.professional === "student" || this.step != 'secondStep'
                  }
                  else {
                    return true;
                  }

                }
              },
              {
                className: 'col-12 mb-lg-2 mb-4',
                key: 'monthlyIncome',
                type: 'currency',
                templateOptions: {
                  label: 'Monthly Income in INR',
                  required: true,
                  placeholder: 'eg. 75,000',
                },
                hideExpression: () => {
                  if (this.model?.loanProcessInformation) {
                    return this.model?.loanProcessInformation?.professional === "student" || this.step != 'secondStep'
                  }
                  else {
                    return true;
                  }

                }
              },
            ],
          },

          {
            className: "col-12",
            key: "pan",
            type: "pan",
            templateOptions: {
              label: "PAN Number",
              placeholder: "Enter PAN",
            },
            hideExpression: () => {
              return !this.isIndianNumber || this.step !== 'secondStep';
            },
            expressionProperties: {
              "templateOptions.required": () => {
                if (this.model?.loanProcessInformation?.professional === "student") {
                  return false
                }
                return true
              }
            },
            asyncValidators: {
              alreadyAvailable: {
                expression: async (control: any) => {
                  let val = await this.checkPanNumber(control.value);
                  if (val?.canContinue === false && control.value) {
                    this.apiHelper.openSnackBar("This pan is already registered")
                    return false
                  }
                  return val?.canContinue || true;
                },
                message: (error, field: FormlyFieldConfig) => `${field.formControl.value} is already registered.`,
              }
            }
          },

          {
            template: `<p class="text-primary">Helps lender verify your credit history.</p>`,
            hideExpression: () => {
              return !this.isIndianNumber || this.step !== 'secondStep';
            },
            expressionProperties: {
              "className": () => {
                if (this.model?.loanProcessInformation?.professional === "student") {
                  return "col-12 "
                }
                else {
                  return "col-12"
                }
              }
            }
          },

          {
            className: "col-12",
            type: "button",
            templateOptions: {
              btnType: "primary w-100 gradient py-3",
              type: "text",
              text: 'Continue  <img src="../../../../assets/logo/next-icon-button.svg" alt="nextIcon">',
              onClick: () => {
                if (this.model?.firstName === undefined || this.model?.lastName === undefined || this?.model?.email === undefined || this.model?.address === undefined || this.model?.dob === undefined) {
                  this.model["error"] = "Hello world"
                }
              },
            },
            expressionProperties: {
              "templateOptions.btnType": (model: any) => {
                if (this.isIndianNumber) {
                  if (this.step === "firstStep") {
                    if ([undefined, "", " "].includes(this.model?.firstName) || [undefined, "", " "].includes(this.model?.lastName) || [undefined, "", " "].includes(this?.model?.email) || [undefined, "", " "].includes(this.model?.address) || [undefined, "", " "].includes(this.model?.dob)) {
                      return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                    }
                    else {
                      return "primary w-100 py-3 fw-bold rounded-custom "
                    }
                  }
                  if (this.step === "secondStep") {
                    if (this.model?.loanProcessInformation?.professional === "student") {
                      if ([undefined, "", " "].includes(this.model?.loanProcessInformation?.professional)) {
                        return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                      }
                      else {
                        return "primary w-100 py-3 fw-bold rounded-custom "
                      }
                    }
                    else {
                      if ([undefined, "", " "].includes(this.model?.loanProcessInformation?.professional) || [undefined, null, "", " "].includes(this.model?.loanProcessInformation?.workExperience) || [undefined, "", " "].includes(this.model?.loanProcessInformation?.monthlyIncome) || [undefined, "", " "].includes(this.model?.pan)) {
                        return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                      }
                      else {
                        return "primary w-100 py-3 fw-bold rounded-custom "
                      }
                    }

                  }

                }
                else {
                  if (this.step === "firstStep") {
                    if ([undefined, "", " "].includes(this.model?.firstName) || [undefined, "", " "].includes(this.model?.lastName) || [undefined, "", " "].includes(this?.model?.email) || [undefined, "", " "].includes(this.model?.address?.city) || [undefined, "", " "].includes(this.model?.address?.state) || [undefined, "", " "].includes(this.model?.address?.country) || [undefined, "", " "].includes(this.model?.dob)) {
                      return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                    }
                    else {
                      return "primary w-100 py-3 fw-bold rounded-custom "
                    }
                  }
                  if (this.step === "secondStep") {
                    if (this.model?.loanProcessInformation?.professional === "student") {
                      if ([undefined, "", " "].includes(this.model?.loanProcessInformation?.professional)) {
                        return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                      }
                      else {
                        return "primary w-100 py-3 fw-bold rounded-custom "
                      }
                    }
                    else {
                      if ([undefined, "", " "].includes(this.model?.loanProcessInformation?.professional) || [undefined, null, "", " "].includes(this.model?.loanProcessInformation?.workExperience) || [undefined, "", " "].includes(this.model?.loanProcessInformation?.monthlyIncome)) {
                        return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                      }
                      else {
                        return "primary w-100 py-3 fw-bold rounded-custom "
                      }
                    }

                  }

                }

              }
            }
          }
        ],
        expressionProperties: {
          "fieldGroupClassName": () => {
            if (this.step === 'firstStep') {
              return "row align-items-center padding-custom content-height custom-height-personal"
            }
            else {
              return "row align-items-center padding-custom content-height custom-height-personal-second"
            }
          }
        }
      }
    ]
  }

  setLayout() {
    this.layout = [
      {
        fieldGroup: [
          {
            className: "col-6",
            key: "firstName",
            type: "input",
            templateOptions: {
              required: true,
              label: "First Name",
              hideRequiredMarker: true,
              placeholder: "Eg. Kiara"
            },
            hideExpression: () => {
              return this.step !== 'firstStep'
            },
            validation: {
              messages: {
                required: 'First Name is required',
              },
            }
          },

          {
            className: "col-6",
            key: "lastName",
            type: "input",
            templateOptions: {
              required: true,
              label: "Last Name",
              hideRequiredMarker: true,
              placeholder: "Eg. Sharma"
            },
            hideExpression: () => {
              return this.step !== 'firstStep'
            },
            validation: {
              messages: {
                required: 'Last Name is required',
              },
            }
          },

          {
            className: "col-12",
            key: "email",
            type: "emailR",
            templateOptions: {
              required: true,
              label: "Email Address",
              hideRequiredMarker: true,
              placeholder: "Eg. xyz23@gmail.com"
            },
            asyncValidators: {
              alreadyApplied: {
                expression: async (control) => {
                  if (control) {
                    let val = await this.checkEmailAvailable(control.value)
                    if (!val?.canContinue) {
                      //this.apiHelper.openSnackBar('Email address already has an Active Loan Application/User already exists')
                    }
                    return val.canContinue;
                  }

                  return true;
                },
                message: (error, field: FormlyFieldConfig) => `${field.formControl.value} already exists`,
              },
            },
            hideExpression: () => {
              return this.step !== 'firstStep'
            },
            validation: {
              messages: {
                required: 'Email is required',
                alreadyApplied: 'You have already applied.'
              },
            }
          },

          {
            className: "col-12",
            key: "address",
            fieldGroupClassName: 'row',
            fieldGroup: [
              {
                className: 'col-12',
                key: 'pincode',
                type: 'autocomplete',
                templateOptions: {
                  label: 'Pincode (Permanent)',
                  required: true,
                  placeholder: 'Type and select Pincode',
                  autocompleteOptions: {
                    name: 'pincode',
                    isEditable: false,
                    value: 'pincode',
                    defaultValue: this.defaultAddress,
                    fields: ['pincode', 'city', 'state'],
                    dataModel: 'locations',
                    onSelect: (item: any) => {
                      this.model.address = {
                        pincode: item.pincode,
                        city: item.city,
                        state: item.state,
                        country: item.country,
                        region: item.region
                      }

                      setTimeout(() => {
                        let newModel = { ...this.model };
                        this.model = undefined;
                        this.model = newModel;
                      }, 100);
                    },
                    dataParams: {
                      aggregate: true
                    }
                  }
                },
                hideExpression: () => {
                  return !this.isIndianNumber || this.step !== 'firstStep';
                },
              },
              {
                className: "col-12",
                key: "city",
                type: "input",
                templateOptions: {
                  label: "City",
                  placeholder: "Eg. Bangalore",
                  required: true,
                  hideRequiredMarker: true,
                },
                validation: {
                  messages: {
                    required: 'City is required',
                  },
                },
                hideExpression: () => this.isIndianNumber || this.step !== 'firstStep'
              },
              {
                className: "col-12",
                key: "state",
                type: "input",
                templateOptions: {
                  label: "State",
                  placeholder: "Eg. Karnataka",
                  required: true,
                  hideRequiredMarker: true,
                },
                validation: {
                  messages: {
                    required: 'State is required',
                  },
                },
                hideExpression: () => this.isIndianNumber || this.step !== 'firstStep'
              },
              {
                className: "col-12",
                key: "country",
                type: "input",
                templateOptions: {
                  label: "Country",
                  placeholder: "Eg. India",
                  required: true,
                  hideRequiredMarker: true,
                },
                validation: {
                  messages: {
                    required: 'Country is required',
                  },
                },
                hideExpression: () => this.isIndianNumber || this.step !== 'firstStep'
              }
            ]
          },

          {
            className: "col-12",
            key: "currentAddress",
            fieldGroupClassName: 'row',
            fieldGroup: [
              {
                className: 'col-12',
                key: 'pincode',
                type: 'autocomplete',
                templateOptions: {
                  label: 'Pincode (Current)',
                  placeholder: 'Type and select Pincode',
                  autocompleteOptions: {
                    name: 'pincode',
                    isEditable: false,
                    value: 'pincode',
                    fields: ['pincode', 'city', 'state'],
                    dataModel: 'locations',
                    defaultValue: this.defaultCurrentAddress,
                    onSelect: (item: any) => {
                      this.model.currentAddress = {
                        pincode: item.pincode,
                        city: item.city,
                        state: item.state,
                        country: item.country,
                        region: item.region
                      }

                      setTimeout(() => {
                        let newModel = { ...this.model };
                        this.model = undefined;
                        this.model = newModel;
                      }, 100);
                    },
                    dataParams: {
                      aggregate: true
                    }
                  }
                },
              },
            ],
            hideExpression: () => {
              return !this.isIndianNumber || this.step !== 'firstStep';
            }
          },
          {
            className: "col-12",
            type: "dob",
            key: "dob",
            templateOptions: {
              label: "Date of birth",
              required: true,
              placeholder: "Enter date of birth"
            },
            hideExpression: () => {
              return this.step !== 'firstStep'
            },
            expressionProperties: {
              "templateOptions.max": (model) => {
                return this.datePipe.transform(new Date(), 'yyyy-MM-dd');
              }
            }
          },

          {
            className: "col-12 buttonRadio ",
            key: "loanProcessInformation",
            fieldGroupClassName: 'row',
            fieldGroup: [
              {
                className: 'col-12',
                key: 'professional',
                type: 'radio',

                templateOptions: {
                  label: 'I am a',
                  required: true,
                  placeholder: 'Select an Option',
                  options: this.professionalOptions
                },
                hideExpression: () => {
                  return this.step != 'secondStep'
                }
              },
              {
                className: 'col-12 mb-lg-2 mb-2',
                key: 'workExperience',
                type: "input",
                templateOptions: {
                  type: "number",
                  label: 'Your work experience in Months',
                  required: true,
                  min: 1,
                  placeholder: 'Enter work experience',
                },
                validation: {
                  messages: {
                    min: "Minimum experience should be greater than 0"
                  },
                },
                hideExpression: () => {
                  if (this.model?.loanProcessInformation) {
                    return this.model?.loanProcessInformation?.professional === "student" || this.step != 'secondStep'
                  }
                  else {
                    return true;
                  }

                }
              },
              {
                className: 'col-12 mb-lg-2 mb-4',
                key: 'monthlyIncome',
                type: 'currency',
                templateOptions: {
                  label: 'Monthly Income in INR',
                  required: true,
                  placeholder: 'eg 75,000',
                },
                hideExpression: () => {
                  if (this.model?.loanProcessInformation) {
                    return this.model?.loanProcessInformation?.professional === "student" || this.step != 'secondStep'
                  }
                  else {
                    return true;
                  }

                }
              },
            ],
          },
          {
            className: "col-12",
            key: "pan",
            type: "pan",
            templateOptions: {
              label: "PAN Number",
              placeholder: "Enter PAN",
            },
            hideExpression: () => {
              return !this.isIndianNumber || this.step !== 'secondStep';
            },
            expressionProperties: {
              "templateOptions.required": () => {
                if (this.model?.loanProcessInformation?.professional === "student") {
                  return false
                }
                return true
              }
            },
            asyncValidators: {
              alreadyAvailable: {
                expression: async (control: any) => {
                  let val = await this.checkPanNumber(control.value);
                  if (val?.canContinue === false && control.value) {
                    this.apiHelper.openSnackBar("This pan is already registered")
                    return false
                  }
                  return val?.canContinue || true;
                },
                message: (error, field: FormlyFieldConfig) => `${field.formControl.value} is already registered.`,
              }
            }
          },

          {
            template: `<p class="text-primary">Helps lender verify your credit history.</p>`,
            hideExpression: () => {
              return !this.isIndianNumber || this.step !== 'secondStep';
            },
            expressionProperties: {
              "className": () => {
                if (this.model?.loanProcessInformation?.professional === "student") {
                  return "col-12 "
                }
                else {
                  return "col-12"
                }
              }
            }
          },
          {
            className: "col-12",
            type: "button",
            templateOptions: {
              btnType: "primary w-100 gradient py-3",
              type: "text",
              text: 'Continue  <img src="../../../../assets/logo/next-icon-button.svg" alt="nextIcon">',
              onClick: () => {
                if (this.model?.firstName === undefined || this.model?.lastName === undefined || this?.model?.email === undefined || this.model?.address === undefined || this.model?.dob === undefined) {
                  this.model["error"] = "Hello world"
                }
              },
            },
            expressionProperties: {
              "templateOptions.btnType": (model: any) => {
                if (this.isIndianNumber) {
                  if (this.step === "firstStep") {
                    if ([undefined, "", " "].includes(this.model?.firstName) || [undefined, "", " "].includes(this.model?.lastName) || [undefined, "", " "].includes(this?.model?.email) || [undefined, "", " "].includes(this.model?.address) || [undefined, "", " "].includes(this.model?.dob) || [undefined, "", " ", null].includes(this.model?.address?.pincode)) {
                      return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                    }
                    else {
                      return "primary w-100 py-3 fw-bold rounded-custom "
                    }
                  }
                  if (this.step === "secondStep") {
                    if (this.model?.loanProcessInformation?.professional === "student") {
                      if ([undefined, "", " "].includes(this.model?.loanProcessInformation?.professional)) {
                        return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                      }
                      else {
                        return "primary w-100 py-3 fw-bold rounded-custom "
                      }
                    }
                    else {
                      if ([undefined, "", " "].includes(this.model?.loanProcessInformation?.professional) || [undefined, null, "", " "].includes(this.model?.loanProcessInformation?.workExperience) || [undefined, "", " "].includes(this.model?.loanProcessInformation?.monthlyIncome) || [undefined, "", " "].includes(this.model?.pan)) {
                        return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                      }
                      else {
                        return "primary w-100 py-3 fw-bold rounded-custom "
                      }
                    }

                  }

                }
                else {
                  if (this.step === "firstStep") {
                    if ([undefined, "", " "].includes(this.model?.firstName) || [undefined, "", " "].includes(this.model?.lastName) || [undefined, "", " "].includes(this?.model?.email) || [undefined, "", " "].includes(this.model?.address?.city) || [undefined, "", " "].includes(this.model?.address?.state) || [undefined, "", " "].includes(this.model?.address?.country) || [undefined, "", " "].includes(this.model?.dob)) {
                      return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                    }
                    else {
                      return "primary w-100 py-3 fw-bold rounded-custom "
                    }
                  }
                  if (this.step === "secondStep") {
                    if (this.model?.loanProcessInformation?.professional === "student") {
                      if ([undefined, "", " "].includes(this.model?.loanProcessInformation?.professional)) {
                        return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                      }
                      else {
                        return "primary w-100 py-3 fw-bold rounded-custom "
                      }
                    }
                    else {
                      if ([undefined, "", " "].includes(this.model?.loanProcessInformation?.professional) || [undefined, null, "", " "].includes(this.model?.loanProcessInformation?.workExperience) || [undefined, "", " "].includes(this.model?.loanProcessInformation?.monthlyIncome)) {
                        return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                      }
                      else {
                        return "primary w-100 py-3 fw-bold rounded-custom "
                      }
                    }

                  }

                }

              }
            }
          }
        ],
        expressionProperties: {
          "fieldGroupClassName": () => {
            if (this.step === 'firstStep') {
              return "row align-items-center padding-custom content-height custom-height-personal"
            }
            else {
              return "row align-items-center padding-custom content-height"
            }
          }
        }
      }
    ]
  }

  setDefaultAddress() {
    if (this.model?.address) {
      this.defaultAddress = "";
      if (this.model?.address?.hasOwnProperty("pincode") && this.model.address.pincode) {
        this.defaultAddress += this.model.address.pincode + " ";
      }
      if (this.model?.address?.hasOwnProperty("state") && this.model?.address?.state) {
        this.defaultAddress += this.model.address.state + " ";
      }
      if (this.model?.address?.hasOwnProperty("city") && this.model?.address?.city) {
        this.defaultAddress += this.model.address.city + " ";
      }
    }
    if (this.model?.currentAddress && Object.keys(this.model?.currentAddress)?.length > 0) {
      this.defaultCurrentAddress = "";
      if (this.model?.currentAddress?.hasOwnProperty("pincode") && this.model.currentAddress.pincode) {
        this.defaultCurrentAddress += this.model.currentAddress.pincode + " ";
      }
      if (this.model?.currentAddress?.hasOwnProperty("state") && this.model?.currentAddress?.state) {
        this.defaultCurrentAddress += this.model.currentAddress.state + " ";
      }
      if (this.model?.currentAddress?.hasOwnProperty("city") && this.model?.currentAddress?.city) {
        this.defaultCurrentAddress += this.model.currentAddress.city + " ";
      }
    }
  }

  dataProcessor(data: any) {
    if (data?.loanProcessInformation && data?.loanProcessInformation?.professional !== "student") {
      data.loanProcessInformation.monthlyIncome = data?.loanProcessInformation?.monthlyIncome?.replaceAll(",", "");
      data.loanProcessInformation.monthlyIncome = data?.loanProcessInformation?.monthlyIncome?.toString();
    }
    if (data?.loanProcessInformation && data?.loanProcessInformation?.professional == "student") {
      delete data.loanProcessInformation?.monthlyIncome
    }

    if (data?.error) {
      delete data?.error
      this.model.error = undefined;
    }

    data.type = "student";
    if (data?.pan) {
      data.pan = data?.pan?.toUpperCase();
    }

    if (data?.passportNumber) {
      data.passportNumber = data?.passportNumber.toUpperCase();
    }

    if (data?.loanProcessInformation?.workExperience) {
      data.loanProcessInformation.workExperience = data?.loanProcessInformation?.workExperience?.toString();
    }

    const storedData = localStorage.getItem('studentDetails');
    if (storedData) {
      const storedObject = JSON.parse(storedData);
      delete storedObject.universityVendors;
      localStorage.setItem('studentDetails', JSON.stringify(storedObject));
    }
    delete data?.academicDetails?.ieltsToeflExam;
    delete data?.academicDetails?.greGmatExam;
    delete data?.academicDetails?.languageExam;
    delete data?.academicDetails?.aptitudeExam;

    if (!data?.currentAddress?.pincode) {
      delete data?.currentAddress?.pincode
      data.currentAddress = {};
    }
    if (data?.address?.id) {
      delete data?.address?.id
    }
    if (data?.currentAddress?.id) {
      delete data?.currentAddress?.id
    }
    if (this.userIdentity.isLoggedIn.getValue()) {
      return data;
    }
    // delete data?.id;
    delete data?.kycStatus;

    if (data?.universityVendors) {
      delete data?.universityVendors;
    }
    return data;
  }

  removeEmpty(obj) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
      else if (typeof obj[propName] == 'object') {
        this.removeEmpty(obj[propName]);
      }
    }
    return obj
  }

  onSubmit(event: any) {
    if (!event?.error) {
      delete this.loanService?.studentDetails?.universityVendors
      this.loanService.saveStudentDetails(this.model, true).then(() => {
        delete this.model?.universityVendors
        this.currentDetails["email"] = this.model?.email;
        this.currentDetails["pan"] = this.model?.pan;
        if (this.orientation == 'horizontal') {
          if (this.step === 'firstStep') {
            setTimeout(() => {
              let newModel = { ...this.model };
              this.model = undefined;
              this.model = newModel;
              this.step = "secondStep";
              this.layout = undefined;
              this.setMobileLayout();
            }, 200)

            this.configPersonalDetailsHeader.title = "What do you do?";
            this.configPersonalDetailsHeader.back = {
              link: '/personal-details',
              step: 'firstStep',
            };
          }
          else if (this.step === 'secondStep') {
            if (this.isPartnerLink) {
              this.route.navigate(['basic-information/' + this.loanService?.partnerDetails?.uid]);
              return;
            }
            this.route.navigate(['basic-information']);
          }
        }
        else {
          if (this.step === 'firstStep') {
            setTimeout(() => {
              let newModel = { ...this.model };
              this.model = undefined;
              this.model = newModel;
              this.step = "secondStep";
              this.layoutForMobileView = undefined;
              this.setMobileLayout();
            }, 200)

            this.configPersonalDetailsHeader.title = "What do you do?";
            this.configPersonalDetailsHeader.back = {
              link: '/personal-details',
              step: 'firstStep',
            };
          }
          else if (this.step === 'secondStep') {
            if (this.isPartnerLink) {
              this.route.navigate(['basic-information/' + this.loanService?.partnerDetails?.uid]);
              return;
            }
            this.route.navigate(['basic-information']);
          }
        }
        sessionStorage.removeItem("stepHeading")
      });

      gtag('event', 'personal_details_submit', {
        'event_category': 'button',
        'event_label': 'Personal details submit button',
        'value': "Personal details"  
      });

      gtag('config','G-LW5LDX8EDG',{
        'user_id': this.model?.mobile
      })
    }
  }

  async checkEmailAvailable(email: string) {
    if (this.currentDetails?.email == email) return { canContinue: true };
    // if (this.model?.id) return 0;
    let params = {
      where: {
        email: { eq: email },
      }
    }
    return this.apiHelper.getData("check-existing-email-widget", params).then((res: any) => {
      return res;
    })
  }

  isValidPincode(pincode: string) {
    return /^(\d{4}|\d{6})$/.test(pincode.toString());
  }

  back() {
    if (this.isPartnerLink) {
      this.route.navigate(['basic-information/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['basic-information'])
  }

  checkPanNumber(pan) {
    if (this.currentDetails?.pan === pan) return { canContinue: true };
    let params = {
      where: {
        pan: pan
      }
    }
    return this.apiHelper.getData("users/check-existing-pan", params).then((res: any) => {
      return res;
    })
  }

  emitStep(ev: any) {
    if (this.step === 'firstStep') {
      if (this.isPartnerLink) {
        this.route.navigate([ev.link + "/" + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate([ev.link])
    }
    else {
      this.configPersonalDetailsHeader.title = "Tell us about Yourself"
      if (this.isPartnerLink) {
        this.route.navigate(["/personal-details/" + this.loanService?.partnerDetails?.uid]);
        this.step = 'firstStep';
        let newModel = { ...this.model };
        this.model = undefined;
        this.model = newModel;
        return;
      }
      this.route.navigate(["/personal-details"]);
      this.step = 'firstStep';
    }

    let newModel = { ...this.model };
    this.model = undefined;
    this.model = newModel;

    // this.step = ev.step
  }
}
